import React from "react";
import { useViewContent } from "@/lib/pixel";
import { Mic, Plus } from "lucide-react";
import { PageHero, Reveal, Overline } from "@/components/primitives";
import LeadDialog from "@/components/forms/LeadDialog";
import { CTAButton } from "@/components/primitives";
import NewsletterForm from "@/components/forms/NewsletterForm";

export default function Speakers() {
  useViewContent("Speakers");
  return (
    <>
      <PageHero
        overline="Speakers"
        title="The voices setting the agenda."
        subtitle="Leaders from across producers, oil companies, automakers, technology and policy. Full line-up announced in stages."
      />

      <section className="bg-parchment py-20 md:py-28">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          {/* Placeholder grid */}
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
            {Array.from({ length: 4 }).map((_, i) => (
              <Reveal key={i} delay={i * 0.06}>
                <div className="aspect-[3/4] overflow-hidden rounded-2xl border border-border bg-white">
                  <div className="flex h-full w-full flex-col items-center justify-center bg-gradient-to-b from-navy/5 to-emerald2/5 text-navy/30">
                    <Mic className="h-10 w-10" />
                    <p className="mt-3 text-sm font-medium">To be announced</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Reveal>
            <div className="mt-14 rounded-3xl border border-border bg-white p-8 text-center shadow-sm md:p-12">
              <h3 className="font-display text-2xl font-bold text-navy">Speaker announcements begin soon.</h3>
              <p className="mt-3 text-navy/60">Want first access? Get the speaker drops straight to your inbox.</p>
              <div className="mx-auto mt-6 max-w-md"><NewsletterForm /></div>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="border-y border-border bg-white py-20 md:py-28">
        <div className="mx-auto max-w-4xl px-6 text-center md:px-12">
          <Reveal>
            <Overline className="mb-4 justify-center">Call for speakers</Overline>
            <h2 className="font-display text-3xl font-semibold tracking-tight text-navy sm:text-4xl">Have something the room needs to hear?</h2>
            <p className="mt-5 text-lg text-navy/70">We're curating sessions on the post-E20 roadmap. If you're shaping ethanol policy, production, technology or finance, propose a session.</p>
            <div className="mt-8 flex justify-center">
              <LeadDialog
                formType="speaker"
                title="Propose a session"
                description="Tell us about you and the session you'd like to lead."
                ctaLabel="Submit proposal"
                successMsg="Proposal received. Our programme team will be in touch."
                extraFields={[{ key: "topic", placeholder: "Proposed topic / session" }]}
                trigger={<CTAButton data-testid="propose-session"><Plus className="h-4 w-4" /> Propose a session</CTAButton>}
              />
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
